<template>
  <a-modal
    title="查看"
    :width="1280"
    :visible="visible"
    :footer="null"
    :bodyStyle="{ height: '700px', overflowY: 'auto' }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-row :gutter="[16,16]" v-if="ladingBillInfo !== undefined">
        <a-divider orientation="left">基础数据 </a-divider>
        <a-col :span="8" v-if="ladingBillInfo.number">
          编号：<span class="important-content">{{ ladingBillInfo.number }}</span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.bill_of_lading_number">
          提单号：<span class="important-content">{{ ladingBillInfo.bill_of_lading_number }}</span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.project">
          采销全流程：<span class="important-content">{{ ladingBillInfo.project }}</span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.bill_of_lading_date">
          提单签发日期：<span class="important-content">{{ ladingBillInfo.bill_of_lading_date }} </span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.shipper">
          发货人：<span class="important-content">{{ ladingBillInfo.shipper }} </span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.consignee">
          收货人：<span class="important-content">{{ ladingBillInfo.consignee }} </span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.carrier">
          承运人：<span class="important-content">{{ ladingBillInfo.carrier }} </span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.notify_party">
          通知方：<span class="important-content">{{ ladingBillInfo.notify_party }} </span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.loading_port">
          装货港：<span class="important-content">{{ ladingBillInfo.loading_port }} </span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.discharge_port">
          卸货港：<span class="important-content">{{ ladingBillInfo.discharge_port }} </span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.cargo_category">
          货物扩展分类：<span class="important-content">{{ dictionaries.trade_lading_bill_type[ladingBillInfo.cargo_category] }} </span>
        </a-col>
        <a-col :span="24" v-if="ladingBillInfo">
          <a-divider orientation="left">{{ dictionaries.trade_lading_bill_type[ladingBillInfo.cargo_category] }}数据</a-divider>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.cargo_category === 1">
          罐号：<span class="important-content">{{ ladingBillInfo['detail']['tank_number'] }}</span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.cargo_category === 1">
          入罐日期：<span class="important-content">{{ ladingBillInfo['detail']['intake_date'] }}</span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.cargo_category === 1">
          对应存量：<span class="important-content">{{ ladingBillInfo['detail']['tank_inventory'] }}</span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.cargo_category === 1">
          岸罐数量：<span class="important-content">{{ ladingBillInfo['detail']['shore_tank_qty'] }}</span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.cargo_category === 2">
          卸货日期：<span class="important-content">{{ ladingBillInfo['detail']['discharge_date'] }} </span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.cargo_category === 3">
          铅封号：<span class="important-content">{{ ladingBillInfo['detail']['seal_number'] }}</span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.cargo_category === 3">
          箱型：<span class="important-content">{{ ladingBillInfo['detail'].container_type }}</span>
        </a-col>
        <a-col :span="8" v-if="ladingBillInfo.cargo_category === 3">
          箱量：<span class="important-content">{{ ladingBillInfo['detail']['container_count'] }}</span>
        </a-col>
        <a-col :span="8">
          毛重：<span class="important-content">{{ ladingBillInfo['detail']['gross_weight']}}</span>
        </a-col>
        <a-col :span="8">
          净重：<span class="important-content">{{ ladingBillInfo['detail']['net_weight']}}</span>
        </a-col>
        <a-col :span="8">
          单位：<span class="important-content">{{ dictionaries.unit[ladingBillInfo['detail']['unit']]}}</span>
        </a-col>
        <a-col :span="24" v-if="ladingBillInfo.cargo_category && fixedPriceList.length > 0">
          <a-divider orientation="left">{{ dictionaries.trade_lading_bill_type[ladingBillInfo.cargo_category] }}附件</a-divider>
        </a-col>
        <a-col :span="24" v-if="ladingBillInfo.cargo_category && fixedPriceList.length > 0">
          <a-table
            style="width: 100%"
            :data-source="fixedPriceList"
            :columns="attachmentColumns"
            :pagination="false">
            <span slot="serial" slot-scope="text, record, index">
              {{ index + 1 }}
            </span>
            <template slot="action" slot-scope="text, record">
              <a @click="watchView(record)">查看</a>
            </template>
          </a-table>
        </a-col>
      </a-row>
      <component
        :ref="currentComponent"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :is="currentComponent"
        :visible="createContractVisible"
        v-if="createContractVisible"
        :loading="confirmLoading"
        :model="mdl" />
      <a-modal
        title="明细"
        v-if="lockPriceDetailVisible"
        :visible="lockPriceDetailVisible"
        :footer="null"
        @cancel="lockPriceDetailVisible=false"
      >
        <div v-for="(item, index) in pointPriceDetailList" :key="index">
          <a-row :gutter="[16,16]">
            <a-col :span="12">
              计价日期：{{ item.lock_price_date }}
            </a-col>
            <a-col :span="12">
              计价价格：{{ item.lock_price }}
            </a-col>
          </a-row>
        </div>
      </a-modal>
    </a-spin>
  </a-modal>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'
import {
  sell_contract_list,
  sell_contract_valence_vertex_price_delete,
   trade_sell_contract_fixed_pricing_details
} from '@/api/trade_sell_contract'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'
import { lading_bill_list } from '@/api/trade_lading_bill'

export default {
  name: 'WatchView',
  props: {
    model: {
      type: Object,
      default: () => {
        return null
      }
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      form: this.$form.createForm(this),
      dictionaries: Dictionaries,
      ladingBillInfo: undefined,
      currentComponent: '',
      createType: 0,
      mdl: {},
      loading: false,
      projectFetching: false,
      sellContractFetching: false,
      projectList: [],
      selectedProjectId: undefined,
      selectedProject: undefined,
      sellContractList: [],
      isServerData: false,
      lockPriceDetailVisible: false,
      createContractVisible: false,
      confirmLoading: false,
      pointPriceDetailList: [],
      fixedPriceList: [],
      cacheFixedPriceList: [],
      editingKey: '',
      attachmentColumns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 100,
          ellipsis: true
        },
        {
          title: '地址',
          dataIndex: 'url',
          width: 300,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 50,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  computed: {
    paymentMethodTitle () {
      return (payment_method) => {
        return '' + (this.dictionaries.trade_pre_payment_method[payment_method] || '')
      }
    },
    futuresContractPreTitle () {
      return (index) => {
        if (index === 0) {
          return ''
        } else if (index === 1) {
          return '转月后'
        } else if (index === 2) {
          return '二次转月后'
        } else {
          return (index + 1) + '次转月后'
        }
      }
    },
    deleteTitle () {
      return (record) => {
        return record.id > 0 ? '删除后数据不会恢复，确定删除吗？' : '确定删除吗？'
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.selectedProject = this.projectList.filter(item => item.id === this.selectedProjectId)[0]
        this.sellContractList = []
        this.form.setFieldsValue({
          sell_contract_id: undefined
        })
        this.form.setFieldsValue({
          client_ids: undefined
        })
        this.handleSellContractSearch()
      }
    },
    handleSellContractChange (value) {
      if (value !== undefined) {
        this.contract = this.sellContractList.filter(item => item.id === value)[0]
        console.log('合同信息', this.contract)
        this.loadData()
      }
    },
    handleSellContractSearch () {
      if (this.selectedProjectId === undefined) {
        return
      }
      this.sellContractFetching = true
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result
      }).finally(() => {
        this.sellContractFetching = false
      })
    },
    loadData () {
      this.loading = true
      lading_bill_list({ id: this.model.id }).then(res => {
        if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
          this.ladingBillInfo = res.data.entries[0]
          if (this.ladingBillInfo.detail && this.ladingBillInfo.detail.attachments) {
            this.fixedPriceList = this.ladingBillInfo.detail.attachments
          }
          // this.loadFixedPriceDetail()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadFixedPriceDetail () {
      if (this.ladingBillInfo === undefined || this.ladingBillInfo.price_type === undefined || this.ladingBillInfo.price_type === null) {
        return
      }
      trade_sell_contract_fixed_pricing_details({ fixed_pricing_id: this.ladingBillInfo.price_type.id }).then(res => {
        if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
          this.fixedPriceList = res.data.entries
          if (this.fixedPriceList) {
            this.fixedPriceList = this.fixedPriceList.map((item, index) => {
              item['key'] = Math.random() * 100000 + index
              item['editable'] = false
              return item
            })
            this.cacheFixedPriceList = [...this.fixedPriceList]
            this.isServerData = true
          }
        }
      })
    },
    tasCreate () {
      this.createType = 1
      this.currentComponent = 'PointPriceApplyCreateForm'
      this.mdl['type'] = this.createType
      this.createContractVisible = true
    },
    triggerCreate () {
      this.createType = 2
      this.currentComponent = 'PointPriceApplyCreateForm'
      this.mdl['type'] = this.createType
      this.createContractVisible = true
    },
    naturalPricingCreate () {
      this.createType = 3
      this.currentComponent = 'PointPriceApplyNaturePriceCreateForm'
      this.mdl['type'] = this.createType
      this.createContractVisible = true
    },
    handleAddCancel () {
      this.createContractVisible = false
      this.createType = 0
      this.mdl = {}
    },
    onDeleteItem (record) {
      const key = record.key
      const dataSource = [...this.fixedPriceList]
      if (record.id) {
        const deleteDataList = dataSource.filter(item => item.key === key)
        if (deleteDataList !== undefined && deleteDataList.length > 0) {
          const deleteData = deleteDataList[0]
          if (deleteData.id) {
            sell_contract_valence_vertex_price_delete(deleteData.id).then(res => {
              if (res.code === 1000) {
                this.fixedPriceList = dataSource.filter(item => item.key !== key)
              }
            })
          } else {
            const dataSource = [...this.fixedPriceList]
            this.fixedPriceList = dataSource.filter(item => item.key !== key)
          }
        }
      } else {
        const dataSource = [...this.fixedPriceList]
        this.fixedPriceList = dataSource.filter(item => item.key !== key)
      }
    },
    editLockPrice (key) {
      const newData = [...this.fixedPriceList]
      const target = newData.find(item => key === item.key)
      this.editingKey = key
      if (target) {
        target.editable = true
        this.fixedPriceList = newData
      }
    },
    saveLockPrice (key) {
      const newData = [...this.fixedPriceList]
      const newcacheFixedPriceList = [...this.cacheFixedPriceList]
      const target = newData.find(item => key === item.key)
      const targetCache = newcacheFixedPriceList.find(item => key === item.key)
      if (target && targetCache) {
        delete target.editable
        this.fixedPriceList = newData
        Object.assign(targetCache, target)
        this.cacheFixedPriceList = newcacheFixedPriceList
      }
      this.editingKey = ''
    },
    cancelLockPrice (key) {
      const newData = [...this.fixedPriceList]
      const target = newData.find(item => key === item.key)
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheFixedPriceList.find(item => key === item.key))
        delete target.editable
        this.fixedPriceList = newData
      }
    },
    handleChange (value, key, column) {
      const newData = [...this.fixedPriceList]
      const target = newData.find(item => key === item.key)
      if (target) {
        target[column] = value
        this.fixedPriceList = newData
      }
    },
    watchView (record) {
      window.open(record.url)
    },
    checkLockDate (values) {
      const futures_contract_lock_date_list = this.ladingBillInfo.price_type.futures_contract_list.map(item => item.lock_up_date)
      console.log('===', futures_contract_lock_date_list)
      const lock_date = new Date(values['lock_date'])
      for (const futuresContractLockDate of futures_contract_lock_date_list) {
        const contractDate = new Date(futuresContractLockDate)
        console.log(contractDate, lock_date, contractDate > lock_date)
        if (contractDate > lock_date) {
          return true
        }
      }
      return false
    },
    checkLockCount (values) {
      const lock_count = parseFloat(values['lock_count'])
      const locked_count = this.fixedPriceList.reduce((total, item) => {
        const val = parseFloat(item['lock_count'])
        return total + (isNaN(val) ? 0 : val)
      }, 0)
      const contract_max_count = this.contract.count * (1 + parseFloat(this.contract.overloading_rate)) - locked_count
      if (lock_count > contract_max_count) {
        return false
      }
      return true
    },
    handleOk (data) {
      const form = this.$refs[this.currentComponent].form
      form.validateFields((errors, values) => {
        if (!errors) {
          if (this.currentComponent === 'PointPriceApplyCreateForm') {
            if (!this.checkLockDate(values)) {
              this.$message.warning('锁价日期不在合同约定的锁价日期范围')
              return
            }
            if (!this.checkLockCount(values)) {
              this.$message.warning('锁价数量超出合同约定的数量范围')
              return
            }
          }
          const date = new Date()
          const key = date.getHours() + '' + date.getMinutes() + '' + date.getSeconds()
          if (this.createType === 3) {
            this.fixedPriceList.push({ ...values, ...data, lock_price_type: this.createType, key: key, editable: false })
          } else {
            this.fixedPriceList.push({ ...values, lock_price_type: this.createType, key: key, editable: false })
          }
          this.cacheFixedPriceList = this.fixedPriceList.map(item => ({ ...item }))
          this.createContractVisible = false
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
